export default __webpack_public_path__ + "static/media/placeholder_portfolio02-jp-web.705d8b8c.png";